import React from 'react';
import { withStyles } from '@material-ui/core';
import { withUserProfile } from '../../../../../../../../userProfile/userProfileContext';
import { formatDateTime, formatTime } from '../../utils';
import styles from '../styles';
import { compose } from 'recompose';
import Detail from './Detail';
import { withAppConfig } from '../../../../../../../../appConfigContext';
import {
  buildGroupCreatedByTooltipLines,
  buildGroupCreatedDateTooltipLines,
  buildGroupPickupCreatedFieldTooltipNodes
} from './groupPickupCreatedDisplay';

const PickupDetails = ({
  classes,
  pickupInfo,
  userData,
  terminalCode,
  configJSON,
  groupMemberPickups
}) => {
  const groupMembers = groupMemberPickups?.length > 0 ? groupMemberPickups : null;
  const hasMultiplePickupsInGroup = Boolean(groupMembers && groupMembers.length > 1);
  const additionalPickupCount = groupMembers && groupMembers.length > 1 ? groupMembers.length - 1 : 0;

  const createdByTooltipLines = groupMembers ? buildGroupCreatedByTooltipLines(groupMembers) : [];
  const createdDateTooltipLines = groupMembers
    ? buildGroupCreatedDateTooltipLines(groupMembers, formatDateTime)
    : [];

  const createdBySummaryValue = groupMembers?.[0]?.createdBy ?? pickupInfo.createdBy;
  const createdDateSummaryValue = groupMembers
    ? formatDateTime(groupMembers[0]?.createdDateTime)
    : formatDateTime(pickupInfo.createdDateTime);

  const sectionTitle = groupMembers ? 'Group Details' : 'Pickup Details';

  const { createdByValueNode, createdDateValueNode } = buildGroupPickupCreatedFieldTooltipNodes({
    classes,
    showGroupedSummary: hasMultiplePickupsInGroup,
    moreOtherPickupsCount: additionalPickupCount,
    createdByFirstDisplay: createdBySummaryValue,
    dateFirstDisplay: createdDateSummaryValue,
    createdByTooltipLines,
    dateTooltipLines: createdDateTooltipLines
  });

  return (
    <div>
      <div className={classes.sectionTitle}>{sectionTitle}</div>
      <div className={classes.pickupDetailsInfoContainer}>
        <div className={classes.pickupDetailsColContainer}>
          <Detail title="Assigned By :" value={pickupInfo.assignedBy} />
          <Detail title="Contact :" value={pickupInfo.shipperContactName} />
          <Detail 
            title="Created by :" 
              value={hasMultiplePickupsInGroup ? createdByValueNode : pickupInfo.createdBy}
          />
          <Detail title="Zone :" value={pickupInfo.dispatchZone} />
        </div>
        <div className={classes.pickupDetailsColContainer}>
          <Detail title="Assigned Time :" value={formatTime(pickupInfo.pickupAssignedDateTime)} />
          <Detail title="Terminal :" value={terminalCode || userData.userProfile.terminal.code} />
          <Detail
            title="Created Date & Time :"
            value={
              hasMultiplePickupsInGroup
                ? createdDateValueNode
                : formatDateTime(pickupInfo.createdDateTime)
            }
          />
          <Detail
            title="Driver :"
            value={`${pickupInfo.driverName ?? ''} ${
              pickupInfo.driverNumber ? `(#${pickupInfo.driverNumber})` : ''
            }`}
          />
        </div>
        <div className={classes.pickupDetailsColContainer}>
          <Detail
            title="Route :"
            value={configJSON?.showStaticRoute ? pickupInfo.staticRoute : pickupInfo.routeName}
          />
          {pickupInfo.driverNumber && (
            <>
              <Detail title="Manifest# :" value={pickupInfo.manifestNumber} />
              <Detail title="Tractor# :" value={pickupInfo.tractorNumber} />
              <Detail title="Trailer# :" value={pickupInfo.trailerNumber} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default compose(withUserProfile, withStyles(styles), withAppConfig)(PickupDetails);
